export const convertBytesPerSecondToMbps = (bytesPerSecond: number) => {
  return +((bytesPerSecond * 8) / 1_000_000).toFixed(2);
};
